import axios from "axios";
import { getSessionToken } from "../../utils/Auth/AuthUtils";

const API_URL = "/api/office";

// Get students
const getOffices = async () => {
  const token = await getSessionToken();

  const config = {
    headers: {
      Authorization: token,
    },
  };

  const response = await axios.get(API_URL + "/all", config);
  // console.log("Offices Service ", response.data);
  return response.data;
};

//Edit student
const editOffice = async (officeData) => {
  const token = await getSessionToken();
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const response = await axios.post(API_URL, officeData, config);

  return response.data;
};

// Get Office
const getOffice = async (officeData) => {
  const token = await getSessionToken();
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const response = await axios.get(API_URL, officeData, config);

  return response.data;
};

const officeService = {
  editOffice,
  getOffice,
  getOffices,
};

export default officeService;
